<template>
    <div class="m-onboard-steps">
        <div :class="{current : (index == current)}" class="m-onboard-step-wrap" v-for="(step, index) in steps">
            <v-layout>
                <div
                        :class="[{past : (index < current)}, {current : (index == current)}, {disabled : ((index) > current)}]"
                        @click="goTo(index)"
                        class="m-onboard-step"
                >
                    <div class="step-number">
                        <e-typography-bold v-if="step.title == $t('pages.dashboard.service.risk-assessment.view.meta.title')">3</e-typography-bold>
                        <e-typography-bold v-else>{{index+1}}</e-typography-bold>
                    </div>
                    <h4 class="m-onboard-step-title">{{step.title}}</h4>
                </div>
            </v-layout>
        </div>
    </div>
</template>

<script>
    import ETypographyBold from "@elements/typography/e-typography-bold";

    export default {
        name: "m-onboard-stepper",
        components: {ETypographyBold},
        props: {
            steps: {
                required: true,
                type: Array
            },
            current: {
                required: true,
                type: Number
            }
        },
        methods: {
            goTo(index) {
                if (this.current > index) this.$emit('goTo', index)
            },
        }
    }
</script>

<style lang="scss">
    .m-onboard {
        &-steps {
            display: flex;
            justify-content: space-between;
            position: relative;


            .pastSteps {
                position: absolute;
                left: 1rem;
                width: 0;
                top: 29px;
                height: 2px;
                transition: width .4s;
            }
            .m-onboard-step {
                @include updatedMedia(md) {
                    padding: 0 !important;
                }
                @include updatedMedia(sm) {
                    margin-left: 1rem;
                }
            }
        }

        &-step-wrap {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 0 1rem 1rem;
            flex: 0 1 auto;
            z-index: 1;
            display: none;

            &:first-of-type {
                margin-left: 0;
            }

            &:last-of-type {
                margin-right: 0;
                position: relative;

            }

            &.current {
                position: relative;
                display: block;
                margin: 1rem 0 1rem 0;

                @include media(md) {
                    margin: 0;
                }
            }
        }

        &-step-title {
            padding: .9rem;
            font-size: 1.7rem;
            color: var(--v-white);

            @include media(md) {
                padding: 1rem 0 1rem 1rem;
                font-size: 1.2rem;
            }
            @include media(sm) {
                font-size: 1rem;
            }
        }

        .step-number {
            border-radius: 50%;
            padding: 1.6rem;
            width: 75px;
            height: 75px;
            text-align: center;
            border: solid 2px var(--v-secondary-base);

            @include media(md) {
                padding: .3rem;
                width: 35px;
                height: 35px;
            }
        }

        &-step {
            color: var(--v-white);
            font-weight: 700;
            background: var(--v-secondary-darken2);
            display: flex;
            align-items: center;

            &,
            & + * {
                transition: background .4s, opacity .4s;
                z-index: 1;
            }

            &.past {
                background: var(--v-primary-base);
                cursor: pointer;
            }

            &.current {
                background: var(--v-primary-base);
            }

            &.disabled {
                background: var(--v-secondary-darken2);

                & + * {
                    opacity: .5;
                }
            }

            .e-typography-bold {
                font-size: 1.7rem;
                color: var(--v-white);

                @include media(md) {
                    font-size: 1.4rem;
                    padding-top: 12px;
                }
            }
        }
    }
</style>